import React, { useEffect, useState } from "react";
import "./App.css";
import "./assets/vendor/nucleo/css/nucleo.css";
import "./assets/vendor/font-awesome/css/font-awesome.min.css";
import "./assets/css/argon-design-system-react.css";

import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Index from "src/views/Index";
import HomePage from "src/pages/HomePage";
import AboutUs from "src/pages/components/layout/AboutUsPage";
import PrivacyPolicy from "src/pages/components/layout/PrivacyPolicy";

import TermsAndCondition from "src/pages/components/layout/TermsAndCondition";
import UserProfile from "src/pages/components/layout/UserProfile";
import SignUpPage from "src/pages/SignUpPage";
import ContactPage from "src/pages/ContactPage";
import JournalLoginPage from "src/pages/JournalLoginPage";
import ReviewersLoginPage from "src/pages/ReviewersLoginPage";
import UserLoginPage from "src/pages/UserLoginPage";
import Card from "src/pages/components/ReviewerCard";
import CardsLayout from "src/pages/CardsLayout";
import JournalProfile from "src/pages/components/layout/JournalProfileDetails";
import PublisherDashboard from "src/pages/components/PublisherDashboard";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "src/assets/custom-style.css";
import { useAppSelector } from "./state/store/store";

import AuthorProfile from "./pages/components/AuthorProfile";
import ReviwerProfile from "./pages/components/ReviwerProfile";
import SearchJournal from "./pages/components/SearchJournal";
import JoinedJournal from "./pages/components/JoinedJournal";
import AddPublication from "./pages/components/AddPublication";
import MyPublications from "./pages/MyPublications";
import MyReviews from "./pages/components/MyReviews";
import ChangePassword from "./pages/components/ChangePassword";
import MyPaper from "./pages/MyPaper";
import PublishRequests from "./components/PublishRequests";
import PublicationList from "./components/PublicationList";
import ForgotPassword from "./pages/components/ForgotPassword";
import CountryFilter from "./pages/components/CountryFilter";
import EditAuthorProfile from "./pages/components/EditAuthorProfile";
import { getNavigation } from "./navigation/NavigationUtils";
import PageNotFound from "./pages/PageNotFound";
import ForgetPassword from "./pages/components/ForgetPassword";
import PasswordReset from "./pages/components/PasswordReset";
import EditPublication from "./pages/components/EditPublication";
import CreateJournalPage from "./pages/CreateJournalPage";
import UpdateJournalPage from "./pages/UpdateJournalPage";

import UpdateResearchPage from "./pages/UpdateResearchPaper";
import CertificatePage from "./pages/certificate/CertificatePage";
import JournalCertificate from "./pages/certificate/JournalCertificate";

function App() {
  const [navList, setNavList] = useState([]);
  const auth = useAppSelector((state) => state.auth);
  useEffect(() => {
    let nav = getNavigation(auth?.activeAccount, auth?.user?.approval_status);
    setNavList(nav);
  }, [auth.activeAccount, auth?.user]);
  return (
    <BrowserRouter>
      <Routes>
        {auth.token != null ? (
          <>
            {navList.map((item, index) => {
              if (item.component)
                return (
                  <Route
                    key={index}
                    path={item.href}
                    Component={item.component}
                  />
                );
            })}
            <Route
              path="/edit-journal/:journalId"
              Component={UpdateJournalPage}
            />
            <Route
              path="/update-research-paper/:researchPaperId"
              Component={UpdateResearchPage}
            />
            <Route path="/update-profile" Component={EditAuthorProfile} />
            <Route path="/edit-publication/:id" Component={EditPublication} />
            <Route path="*" element={<Navigate to={""} />} />
          </>
        ) : (
          <>
            <Route path="/" Component={HomePage} />
            <Route path="/signup" Component={SignUpPage} />
            <Route path="/publisher-login" Component={JournalLoginPage} />
            <Route path="/reviewers-login" Component={ReviewersLoginPage} />
            <Route path="/author-login" Component={UserLoginPage} />
            <Route path="/contact" Component={ContactPage} />
            <Route path="/demo" Component={Index} />
            <Route path="/card" Component={CardsLayout} />
            <Route path="/about-us" Component={AboutUs} />
            <Route path="/privacy-policy" Component={PrivacyPolicy} />
            <Route path="/terms-condition" Component={TermsAndCondition} />
            <Route path="/reviewer-profile/:id" Component={UserProfile} />
            <Route
              path="/reviewer-certificate/:id"
              Component={CertificatePage}
            />
            <Route
              path="/journal-certificate/:id"
              Component={JournalCertificate}
            />
            <Route path="/edit-publication/:id" Component={EditPublication} />
            <Route path="/journal-profile" Component={JournalProfile} />
            <Route path="/forget-password" Component={ForgetPassword} />
            <Route
              path="/password-reset/:reset_token"
              Component={PasswordReset}
            />
            <Route path="/country" Component={CountryFilter} />
            <Route path="*" Component={PageNotFound}></Route>
            <Route
              path="/journal-profile/:journal_id"
              Component={JournalProfile}
            />

            {/* <Route path="/create-journal" Component={CreateJournal} /> */}
          </>
        )}
      </Routes>
      <ToastContainer position="top-right" />
    </BrowserRouter>
  );
}

export default App;
